var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.user
        ? [
            _vm.$route.query &&
            ("register" in this.$route.query ||
              "forgot_password" in this.$route.query ||
              "change_password" in this.$route.query ||
              "confirm_registration" in this.$route.query)
              ? [
                  "register" in this.$route.query &&
                  this.$route.query.register == "yes"
                    ? [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "person person_registration" },
                          [
                            _c("h1", { staticClass: "person__title" }, [
                              _vm._v("Регистрация"),
                            ]),
                            _vm._v(" "),
                            _vm.isSend
                              ? [
                                  _c("p", { staticClass: "person__text" }, [
                                    _vm._v(
                                      "\n              На указанный вами e-mail было выслано письмо с информацией о подтверждении почтового ящика, пожалуйста,\n              перейдите по ссылке в нем, чтобы завершить регистрацию.\n            "
                                    ),
                                  ]),
                                ]
                              : [
                                  _c("p", { staticClass: "person__text" }, [
                                    _vm._v(
                                      "\n              После отправки данных с вами свяжется менеджер\n              для их подтверждения.\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "person__text" }, [
                                    _vm._v(
                                      "\n              * - поля обязательны к заполнению.\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "person__ui-form" },
                                    [
                                      _c(
                                        "form",
                                        {
                                          staticClass:
                                            "form-data form-data_type_ui_registration form-data_theme_bordered",
                                          attrs: { method: "post" },
                                          on: {
                                            submit: function ($event) {
                                              $event.preventDefault()
                                              _vm.isUseCaptcha
                                                ? _vm.validate()
                                                : _vm.register()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "fieldset",
                                            { staticClass: "form-data__group" },
                                            [
                                              _c(
                                                "legend",
                                                {
                                                  staticClass:
                                                    "form-data__group-title",
                                                },
                                                [_vm._v("Данные организации")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _vm._m(1),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "ИНН",
                                                      rules: "required",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.orgInn,
                                                                    expression:
                                                                      "orgInn",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-data__input require",
                                                                attrs: {
                                                                  type: "text",
                                                                  name: "UF_INN",
                                                                  id: "inn",
                                                                  required: "",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.orgInn,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.orgInn =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "form-data__error",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      1141378159
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _vm._m(2),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "Полное название",
                                                      rules: "required",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.orgName,
                                                                    expression:
                                                                      "orgName",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-data__input require",
                                                                attrs: {
                                                                  type: "text",
                                                                  name: "WORK_COMPANY",
                                                                  required: "",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.orgName,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.orgName =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "form-data__error",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      3506789697
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _vm._m(3),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "fo-select-block select select_theme_bordered js-select",
                                                      staticStyle: {
                                                        width:
                                                          "calc(100% - 205px)",
                                                      },
                                                    },
                                                    [
                                                      _c("ValidationProvider", {
                                                        attrs: {
                                                          name: "Страна",
                                                          rules: "required",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function ({
                                                                errors,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.orgCountry,
                                                                            expression:
                                                                              "orgCountry",
                                                                          },
                                                                        ],
                                                                      staticClass:
                                                                        "select__input require",
                                                                      attrs: {
                                                                        name: "UF_COUNTRY",
                                                                        required:
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            var $$selectedVal =
                                                                              Array.prototype.filter
                                                                                .call(
                                                                                  $event
                                                                                    .target
                                                                                    .options,
                                                                                  function (
                                                                                    o
                                                                                  ) {
                                                                                    return o.selected
                                                                                  }
                                                                                )
                                                                                .map(
                                                                                  function (
                                                                                    o
                                                                                  ) {
                                                                                    var val =
                                                                                      "_value" in
                                                                                      o
                                                                                        ? o._value
                                                                                        : o.value
                                                                                    return val
                                                                                  }
                                                                                )
                                                                            _vm.orgCountry =
                                                                              $event
                                                                                .target
                                                                                .multiple
                                                                                ? $$selectedVal
                                                                                : $$selectedVal[0]
                                                                          },
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.countries,
                                                                      function (
                                                                        country
                                                                      ) {
                                                                        return _c(
                                                                          "option",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                value:
                                                                                  country.id,
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                country.label
                                                                              )
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "form-data__error",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          errors[0]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          false,
                                                          2406864152
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-data__label",
                                                    },
                                                    [_vm._v("Основной телефон")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "Основной телефон",
                                                      rules: {
                                                        regex:
                                                          /\+?\d\s*\(?-?\s*(\d{3})\s*\)?-?\s*(\d{3})\s*-?\s*(\d{2})\s*-?\s*(\d{2})(\s+(д\.?|доб\.?|ext\.?)?\s*\(?([\d-]{1,5})\)?)?/,
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.orgPhone,
                                                                    expression:
                                                                      "orgPhone",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-data__input",
                                                                attrs: {
                                                                  type: "tel",
                                                                  name: "WORK_PHONE",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.orgPhone,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.orgPhone =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "form-data__error",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      560066696
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _vm._m(4),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "fo-select-block select select_theme_bordered js-select",
                                                      staticStyle: {
                                                        width:
                                                          "calc(100% - 205px)",
                                                      },
                                                    },
                                                    [
                                                      _c("ValidationProvider", {
                                                        attrs: {
                                                          name: "Федеральный округ",
                                                          rules: "required",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function ({
                                                                errors,
                                                              }) {
                                                                return [
                                                                  _c(
                                                                    "select",
                                                                    {
                                                                      directives:
                                                                        [
                                                                          {
                                                                            name: "model",
                                                                            rawName:
                                                                              "v-model",
                                                                            value:
                                                                              _vm.orgFo,
                                                                            expression:
                                                                              "orgFo",
                                                                          },
                                                                        ],
                                                                      staticClass:
                                                                        "select__input require",
                                                                      attrs: {
                                                                        name: "UF_FO",
                                                                        required:
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            var $$selectedVal =
                                                                              Array.prototype.filter
                                                                                .call(
                                                                                  $event
                                                                                    .target
                                                                                    .options,
                                                                                  function (
                                                                                    o
                                                                                  ) {
                                                                                    return o.selected
                                                                                  }
                                                                                )
                                                                                .map(
                                                                                  function (
                                                                                    o
                                                                                  ) {
                                                                                    var val =
                                                                                      "_value" in
                                                                                      o
                                                                                        ? o._value
                                                                                        : o.value
                                                                                    return val
                                                                                  }
                                                                                )
                                                                            _vm.orgFo =
                                                                              $event
                                                                                .target
                                                                                .multiple
                                                                                ? $$selectedVal
                                                                                : $$selectedVal[0]
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "option",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              value:
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "(не выбрано)"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm._l(
                                                                        _vm.fos,
                                                                        function (
                                                                          fo
                                                                        ) {
                                                                          return _c(
                                                                            "option",
                                                                            {
                                                                              domProps:
                                                                                {
                                                                                  value:
                                                                                    fo.id,
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  fo.label
                                                                                )
                                                                              ),
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                    ],
                                                                    2
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "form-data__error",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          errors[0]
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          false,
                                                          2958875976
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _vm._m(5),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "Город",
                                                      rules: "required",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.orgCity,
                                                                    expression:
                                                                      "orgCity",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-data__input require",
                                                                attrs: {
                                                                  type: "text",
                                                                  name: "WORK_CITY",
                                                                  required: "",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.orgCity,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.orgCity =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "form-data__error",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      688709793
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "fieldset",
                                            { staticClass: "form-data__group" },
                                            [
                                              _c(
                                                "legend",
                                                {
                                                  staticClass:
                                                    "form-data__group-title",
                                                },
                                                [_vm._v("Личные данные")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _vm._m(6),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "Контактное лицо",
                                                      rules: {
                                                        regex:
                                                          /[а-яА-яёЁ\s-]+/m,
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.name,
                                                                    expression:
                                                                      "name",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-data__input require",
                                                                attrs: {
                                                                  type: "text",
                                                                  name: "USER_NAME",
                                                                  required: "",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.name,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.name =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "form-data__error",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      3543556945
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _vm._m(7),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "E-mail",
                                                      rules: "required|email",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.email,
                                                                    expression:
                                                                      "email",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-data__input require",
                                                                attrs: {
                                                                  type: "email",
                                                                  name: "USER_EMAIL",
                                                                  required: "",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.email,
                                                                },
                                                                on: {
                                                                  blur: _vm.checkMail,
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.email =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "form-data__error",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      891709243
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-data__message",
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "form-data__error",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.message
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _vm._m(8),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "Контактный телефон",
                                                      rules: {
                                                        regex:
                                                          /\+?\d\s*\(?-?\s*(\d{3})\s*\)?-?\s*(\d{3})\s*-?\s*(\d{2})\s*-?\s*(\d{2})/,
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.phone,
                                                                    expression:
                                                                      "phone",
                                                                  },
                                                                  {
                                                                    name: "mask",
                                                                    rawName:
                                                                      "v-mask",
                                                                    value:
                                                                      _vm.phoneMask,
                                                                    expression:
                                                                      "phoneMask",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-data__input require",
                                                                attrs: {
                                                                  type: "tel",
                                                                  name: "PERSONAL_PHONE",
                                                                  required: "",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.phone,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.phone =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "form-data__error",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      1273827138
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "fieldset",
                                            { staticClass: "form-data__group" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-data__label",
                                                    },
                                                    [_vm._v("Пароль")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "Пароль",
                                                      rules:
                                                        "confirmed:passwordConfirm",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.password,
                                                                    expression:
                                                                      "password",
                                                                  },
                                                                ],
                                                                staticClass:
                                                                  "form-data__input require",
                                                                attrs: {
                                                                  type: "password",
                                                                  name: "USER_PASSWORD",
                                                                  required: "",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.password,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.password =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "form-data__error",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      3478855595
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-data__parametr form-data__parametr_row",
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form-data__label",
                                                    },
                                                    [_vm._v("Повторите пароль")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    attrs: {
                                                      name: "Повторите пароль",
                                                      vid: "passwordConfirm",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function ({
                                                            errors,
                                                          }) {
                                                            return [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      _vm.passwordConfirm,
                                                                    expression:
                                                                      "passwordConfirm",
                                                                  },
                                                                ],
                                                                ref: "repeatedPasswordEl",
                                                                staticClass:
                                                                  "form-data__input require",
                                                                attrs: {
                                                                  type: "password",
                                                                  name: "USER_CONFIRM_PASSWORD",
                                                                  required: "",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    _vm.passwordConfirm,
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      )
                                                                        return
                                                                      _vm.passwordConfirm =
                                                                        $event.target.value
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "form-data__error",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      errors[0]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      1694576769
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.isUseCaptcha
                                                ? [
                                                    _c("vue-recaptcha", {
                                                      ref: "recaptcha",
                                                      attrs: {
                                                        size: "invisible",
                                                        sitekey: _vm.siteKey,
                                                      },
                                                      on: {
                                                        verify: _vm.register,
                                                        expired:
                                                          _vm.onCaptchaExpired,
                                                      },
                                                    }),
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm._m(9),
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  "forgot_password" in this.$route.query &&
                  this.$route.query.forgot_password == "yes"
                    ? [
                        _c("div", { staticClass: "person person_enter" }, [
                          _c("h1", { staticClass: "person__title" }, [
                            _vm._v("\n            Восстановление\n          "),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "person__ui-form" }, [
                            _c(
                              "form",
                              {
                                staticClass:
                                  "form-data form-data_type_ui_enter form-data_theme_bordered",
                                attrs: { method: "post" },
                                on: { submit: _vm.forgotPassword },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-data__parametr form-data__parametr_row",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-data__label" },
                                      [_vm._v("E-mail")]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "E-mail",
                                        rules: "required|email",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.email,
                                                      expression: "email",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-data__input require",
                                                  attrs: {
                                                    type: "email",
                                                    name: "USER_EMAIL",
                                                    required: "",
                                                  },
                                                  domProps: {
                                                    value: _vm.email,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.email =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-data__error",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2820870155
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-data__message" },
                                  [
                                    _c("span", {
                                      staticClass: "form-data__error",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.message),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._m(10),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  "change_password" in this.$route.query &&
                  this.$route.query.change_password == "yes"
                    ? [
                        _c("div", { staticClass: "person person_enter" }, [
                          _c("h1", { staticClass: "person__title" }, [
                            _vm._v(
                              "\n            Изменение пароля\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "person__ui-form" }, [
                            _c(
                              "form",
                              {
                                staticClass:
                                  "form-data form-data_theme_bordered",
                                attrs: { name: "form_auth", method: "post" },
                                on: { submit: _vm.changePassword },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-data__parametr form-data__parametr_row",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-data__label" },
                                      [_vm._v("Логин")]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "Логин",
                                        rules: "required|email",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.login,
                                                      expression: "login",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-data__input require",
                                                  attrs: {
                                                    type: "email",
                                                    name: "USER_LOGIN",
                                                    required: "",
                                                  },
                                                  domProps: {
                                                    value: _vm.login,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.login =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-data__error",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        4031013124
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-data__parametr form-data__parametr_row",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-data__label" },
                                      [_vm._v("Контрольная строка")]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "Контрольная строка",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.checkWord,
                                                      expression: "checkWord",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-data__input require",
                                                  attrs: {
                                                    type: "text",
                                                    name: "USER_CHECKWORD",
                                                    required: "",
                                                  },
                                                  domProps: {
                                                    value: _vm.checkWord,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.checkWord =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-data__error",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2029375358
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-data__parametr form-data__parametr_row",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-data__label" },
                                      [_vm._v("Пароль")]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "Пароль",
                                        rules: "confirmed:passwordConfirm",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.password,
                                                      expression: "password",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-data__input require",
                                                  attrs: {
                                                    type: "password",
                                                    name: "USER_PASSWORD",
                                                    required: "",
                                                  },
                                                  domProps: {
                                                    value: _vm.password,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.password =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-data__error",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        3478855595
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-data__parametr form-data__parametr_row",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-data__label" },
                                      [_vm._v("Повторите пароль")]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "Повторите пароль",
                                        vid: "passwordConfirm",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.passwordConfirm,
                                                      expression:
                                                        "passwordConfirm",
                                                    },
                                                  ],
                                                  ref: "repeatedPasswordEl",
                                                  staticClass:
                                                    "form-data__input require",
                                                  attrs: {
                                                    type: "password",
                                                    name: "USER_CONFIRM_PASSWORD",
                                                    required: "",
                                                  },
                                                  domProps: {
                                                    value: _vm.passwordConfirm,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.passwordConfirm =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-data__error",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1694576769
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form-data__message" },
                                      [
                                        _c("span", {
                                          staticClass: "form-data__error",
                                          domProps: {
                                            innerHTML: _vm._s(_vm.message),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._m(11),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  "confirm_phone" in this.$route.query &&
                  this.$route.query.confirm_registration == "yes"
                    ? [
                        _c("div", { staticClass: "person person_enter" }, [
                          _c("h1", { staticClass: "person__title" }, [
                            _vm._v(
                              "\n            Подтверждение регистрации\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "person__ui-form" }, [
                            _c(
                              "form",
                              {
                                staticClass:
                                  "form-data form-data_theme_bordered",
                                attrs: {
                                  name: "confirmation_auth",
                                  method: "post",
                                },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.confirmation.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-data__parametr form-data__parametr_row",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-data__label" },
                                      [_vm._v("Email")]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "Email",
                                        rules: "required|email",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.email,
                                                      expression: "email",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-data__input require",
                                                  attrs: {
                                                    type: "email",
                                                    name: "USER_EMAIL",
                                                    required: "",
                                                  },
                                                  domProps: {
                                                    value: _vm.email,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.email =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-data__error",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2820870155
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-data__parametr form-data__parametr_row",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-data__label" },
                                      [_vm._v("Код подтверждения")]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "Код подтверждения",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.confirmCode,
                                                      expression: "confirmCode",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-data__input require",
                                                  attrs: {
                                                    type: "text",
                                                    name: "CONFIRM_CODE",
                                                    required: "",
                                                  },
                                                  domProps: {
                                                    value: _vm.confirmCode,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.confirmCode =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-data__error",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        536080664
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form-data__message" },
                                      [
                                        _c("span", {
                                          staticClass: "form-data__error",
                                          domProps: {
                                            innerHTML: _vm._s(_vm.message),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._m(12),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  "confirm_registration" in this.$route.query &&
                  this.$route.query.confirm_registration == "yes"
                    ? [
                        _c("div", { staticClass: "person person_enter" }, [
                          _c("h1", { staticClass: "person__title" }, [
                            _vm._v(
                              "\n            Подтверждение регистрации\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "person__ui-form" }, [
                            _c(
                              "form",
                              {
                                staticClass:
                                  "form-data form-data_theme_bordered",
                                attrs: {
                                  name: "confirmation_auth",
                                  method: "post",
                                },
                                on: {
                                  submit: function ($event) {
                                    $event.preventDefault()
                                    return _vm.confirmation.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-data__parametr form-data__parametr_row",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-data__label" },
                                      [_vm._v("Email")]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "Email",
                                        rules: "required|email",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.email,
                                                      expression: "email",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-data__input require",
                                                  attrs: {
                                                    type: "email",
                                                    name: "USER_EMAIL",
                                                    required: "",
                                                  },
                                                  domProps: {
                                                    value: _vm.email,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.email =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-data__error",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2820870155
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-data__parametr form-data__parametr_row",
                                  },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "form-data__label" },
                                      [_vm._v("Код подтверждения")]
                                    ),
                                    _vm._v(" "),
                                    _c("ValidationProvider", {
                                      attrs: {
                                        name: "Код подтверждения",
                                        rules: "required",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.confirmCode,
                                                      expression: "confirmCode",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-data__input require",
                                                  attrs: {
                                                    type: "text",
                                                    name: "CONFIRM_CODE",
                                                    required: "",
                                                  },
                                                  domProps: {
                                                    value: _vm.confirmCode,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.confirmCode =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "form-data__error",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        536080664
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form-data__message" },
                                      [
                                        _c("span", {
                                          staticClass: "form-data__error",
                                          domProps: {
                                            innerHTML: _vm._s(_vm.message),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._m(13),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                ]
              : [
                  _c("div", { staticClass: "person person_enter" }, [
                    _c("h1", { staticClass: "person__title" }, [
                      _vm._v("Авторизация"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "person__ui-form" }, [
                      _c(
                        "form",
                        {
                          staticClass:
                            "form-data form-data_type_ui_enter form-data_theme_bordered",
                          attrs: { name: "form_auth" },
                          on: { submit: _vm.authForm },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-data__parametr form-data__parametr_row",
                            },
                            [
                              _c("label", { staticClass: "form-data__label" }, [
                                _vm._v("E-mail"),
                              ]),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                attrs: {
                                  name: "E-mail",
                                  rules: "required|email",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.login,
                                                expression: "login",
                                              },
                                            ],
                                            staticClass: "form-data__input",
                                            attrs: {
                                              type: "email",
                                              name: "USER_LOGIN",
                                            },
                                            domProps: { value: _vm.login },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.login = $event.target.value
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "form-data__error" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2834124118
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-data__parametr form-data__parametr_row",
                            },
                            [
                              _c("label", { staticClass: "form-data__label" }, [
                                _vm._v("Пароль"),
                              ]),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                attrs: { name: "Пароль", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.password,
                                                expression: "password",
                                              },
                                            ],
                                            staticClass: "form-data__input",
                                            attrs: {
                                              type: "password",
                                              maxlength: "255",
                                              autocomplete: "off",
                                              name: "USER_PASSWORD",
                                            },
                                            domProps: { value: _vm.password },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.password =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "form-data__error" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3414502282
                                ),
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-data__message" }, [
                                _c("span", {
                                  staticClass: "form-data__error",
                                  domProps: { innerHTML: _vm._s(_vm.message) },
                                }),
                              ]),
                              _vm._v(" "),
                              _vm._m(14),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._m(15),
                          _vm._v(" "),
                          _vm._m(16),
                        ]
                      ),
                    ]),
                  ]),
                ],
          ]
        : [
            _c("p", { staticClass: "notetext" }, [
              _vm._v("Вы зарегистрированы и успешно авторизовались."),
            ]),
            _vm._v(" "),
            _vm._m(17),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "notice notice_type_info" }, [
      _c("div", { staticClass: "notice__content" }, [
        _vm._v(
          "\n            Наша Компания осуществляет только оптовую продажу игрушек. Мы сотрудничаем только\n            с юридическими лицами и индивидуальными предпринимателями на основании\n            договоров поставки.\n          "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-data__label" }, [
      _vm._v("ИНН "),
      _c("span", { staticClass: "bx-authform-starrequired" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-data__label" }, [
      _vm._v("Полное название "),
      _c("span", { staticClass: "bx-authform-starrequired" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-data__label" }, [
      _vm._v("Страна "),
      _c("span", { staticClass: "bx-authform-starrequired" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-data__label" }, [
      _vm._v("\n                      Федеральный округ "),
      _c("span", { staticClass: "bx-authform-starrequired" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-data__label" }, [
      _vm._v("Город "),
      _c("span", { staticClass: "bx-authform-starrequired" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-data__label" }, [
      _vm._v("Контактное лицо (ФИО) "),
      _c("span", { staticClass: "bx-authform-starrequired" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-data__label" }, [
      _vm._v("E-mail "),
      _c("span", { staticClass: "bx-authform-starrequired" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "form-data__label" }, [
      _vm._v("Контактный телефон "),
      _c("span", { staticClass: "bx-authform-starrequired" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "form-data__parametr form-data__parametr_row_full" },
      [
        _c(
          "a",
          { staticClass: "form-data__action-link", attrs: { href: "/auth/" } },
          [_vm._v("У меня уже есть аккаунт")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "form-data__button button button_theme_primary_blue button_size_md",
            attrs: { name: "Register", type: "submit" },
          },
          [
            _vm._v(
              "\n                      Зарегистрироваться\n                    "
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "form-data__parametr form-data__parametr_row_full" },
      [
        _c(
          "a",
          {
            staticClass: "form-data__action-link",
            attrs: { href: "/auth/?register=yes" },
          },
          [_vm._v("Зарегистрироваться")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "form-data__button button button_theme_primary_blue button_size_md",
            attrs: { type: "submit", name: "send_account_info" },
          },
          [_vm._v("\n                  Восстановить\n                ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "form-data__parametr form-data__parametr_row_full" },
      [
        _c(
          "a",
          { staticClass: "form-data__action-link", attrs: { href: "/auth/" } },
          [_vm._v("Авторизация")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "form-data__button button button_theme_primary_blue button_size_md",
            attrs: { type: "submit", name: "change_pwd" },
          },
          [_vm._v("\n                  Изменить пароль\n                ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "form-data__parametr form-data__parametr_row_full" },
      [
        _c(
          "button",
          {
            staticClass:
              "form-data__button button button_theme_primary_blue button_size_md",
            attrs: { type: "submit", name: "confirm_code" },
          },
          [_vm._v("\n                  Подтвердить\n                ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "form-data__parametr form-data__parametr_row_full" },
      [
        _c(
          "button",
          {
            staticClass:
              "form-data__button button button_theme_primary_blue button_size_md",
            attrs: { type: "submit", name: "confirm_code" },
          },
          [_vm._v("\n                  Подтвердить\n                ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-data__parametr-box" }, [
      _c(
        "a",
        {
          staticClass: "form-data__hint-link",
          attrs: { href: "/auth/?forgot_password=yes" },
        },
        [_vm._v("Забыли\n                  пароль?")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "login-popup-checbox-block form-data__parametr-box" },
      [
        _c("input", {
          staticClass: "adm-designed-checkbox",
          attrs: {
            type: "checkbox",
            id: "USER_REMEMBER",
            name: "USER_REMEMBER",
            value: "Y",
            tabindex: "3",
          },
        }),
        _c("label", {
          staticClass: "adm-designed-checkbox-label",
          attrs: { for: "USER_REMEMBER" },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "login-popup-checkbox-label",
            attrs: { for: "USER_REMEMBER" },
          },
          [_vm._v("Запомнить меня на этом компьютере")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "form-data__parametr form-data__parametr_row_full" },
      [
        _c(
          "a",
          {
            staticClass: "form-data__action-link",
            attrs: { href: "/auth/?register=yes" },
          },
          [_vm._v("Зарегистрироваться")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "form-data__button button button_theme_primary_blue button_size_md",
            attrs: { name: "Login", type: "submit" },
          },
          [_vm._v("Войти\n              ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("a", { attrs: { href: "/" } }, [
        _vm._v("Вернуться на главную страницу"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }